import {fetchWrapper} from "../Helpers/fetchWrapper";
import { apiService } from './apiService';

const getGeoJsonTypes = (orgId) => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/geojsontype/${orgId}`);
};

const createGeoJsonType = (geoJson) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/geojsontype`, geoJson);
};

const updateGeoJsonType = (geoJson) => {
    return fetchWrapper.put(`${apiService.getApiUrl()}/geojsontype`, geoJson);
};

const deleteGeoJsonType = (geoJsonTypeId) => {
    return fetchWrapper.deleteRequest(`${apiService.getApiUrl()}/geojsontype/${geoJsonTypeId}`);
};

const createOrg = (org) => {
    return fetchWrapper.post(`${apiService.getApiUrl()}/org`, org);
};

const updateOrg = (org) => {
    return fetchWrapper.put(`${apiService.getApiUrl()}/org`, org);
};

const getOrgs = () => {
    return fetchWrapper.get(`${apiService.getApiUrl()}/org`);
};

export const orgService = {
    getGeoJsonTypes,
    createGeoJsonType,
    updateGeoJsonType,
    deleteGeoJsonType,
    createOrg,
    updateOrg,
    getOrgs
};
